import React from "react";

/**
 * Milkath brand logo — uses the official uploaded logo asset.
 * Do not modify, recolor or replace. Only sizes/wordmark visibility change.
 */
export function Logo({ className = "", showText = true, size = 32 }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="milkath-logo">
      <img
        src="/milkath-logo.png"
        alt="Milkath"
        width={size}
        height={size}
        className="rounded-lg shrink-0"
        style={{ width: size, height: size, objectFit: "contain" }}
      />
      {showText && (
        <span
          className="text-zinc-50 font-semibold tracking-tight"
          style={{ fontFamily: "var(--font-heading)", fontSize: size * 0.6 + 4 }}
        >
          Milkath
        </span>
      )}
    </div>
  );
}
